import React from 'react'
import { Card, CardHeader, CardContent, Skeleton } from '@duck/ui'

interface AssignmentsListSkeletonProps {
  variant?: 'detailed' | 'simple'
}

export const AssignmentsListSkeleton: React.FC<AssignmentsListSkeletonProps> = ({
  variant = 'detailed'
}) => {
  if (variant === 'simple') {
    return (
      <div className="space-y-6">
        {[1, 2, 3].map(i => (
          <Card key={i}>
            <CardHeader>
              <Skeleton className="h-6 w-48 mb-2" />
              <Skeleton className="h-4 w-64" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-32 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {[1, 2, 3].map(i => (
        <Card key={i}>
          <CardHeader>
            <div className="flex items-start justify-between gap-4">
              <Skeleton className="h-7 w-48" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-8 w-8 rounded" />
              </div>
            </div>
            <div className="space-y-3 pt-2">
              <div className="flex flex-col gap-2">
                <div className="flex flex-row">
                  <Skeleton className="h-4 w-32" />
                  <div className="text-right flex-1">
                    <div className="flex-row flex items-center justify-end gap-4">
                      <Skeleton className="h-4 w-32 hidden md:block" />
                      <Skeleton className="h-6 w-36" />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row flex-wrap gap-2 lg:gap-4">
                  <Skeleton className="h-4 w-40" />
                  <Skeleton className="h-4 w-40" />
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {[1, 2, 3].map(j => (
                <div
                  key={j}
                  className="flex items-center gap-4 py-2 px-3"
                >
                  <Skeleton className="h-4 w-32" />
                  <div className="flex flex-wrap items-center gap-3 flex-1">
                    <Skeleton className="h-6 w-20 rounded-full" />
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-4 w-28" />
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
